/* fl-nav-tree: obsluga 4. poziomu menu i dropdownow breadcrumbs (touch/klik) */
(function () {
  'use strict';

  var isDesktop = function () {
    return window.matchMedia('(min-width: 769px)').matches;
  };

  /* nav.breadcrumbs bywa ustawiony na overflow:hidden (custom CSS sklepu) — to przycina
     dropdown okruszka. Oznaczamy nav klasa, ktora w fl-nav-tree.css wymusza overflow:visible. */
  function markCrumbNavs(root) {
    (root || document).querySelectorAll('.fl-crumb').forEach(function (crumb) {
      var nav = crumb.closest('.breadcrumbs');
      if (nav) nav.classList.add('fl-crumbs-nav');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { markCrumbNavs(); });
  } else {
    markCrumbNavs();
  }
  // sekcje bywaja przeladowywane dynamicznie (warianty produktu, edytor motywu)
  document.addEventListener('shopify:section:load', function (evt) { markCrumbNavs(evt.target); });
  window.addEventListener('load', function () { markCrumbNavs(); });

  /* Flyout otwiera sie TUZ OBOK strzalki (a nie za cala szerokoscia kolumny),
     a gdy brakuje miejsca po prawej — po lewej stronie strzalki. */
  function positionFlyout(li) {
    var menu = li.querySelector('.fl-l4');
    var row = li.querySelector('.fl-l4-row');
    var btn = li.querySelector('.fl-l4-toggle');
    if (!menu || !isDesktop()) return;

    menu.classList.remove('fl-l4--flip');
    menu.style.insetInlineStart = '';
    menu.style.insetInlineEnd = '';

    var liRect = li.getBoundingClientRect();
    var anchorRect = (btn || row || li).getBoundingClientRect();
    var GAP = 8;
    // offset liczony wzgledem <li> (flyout jest wzgledem niego pozycjonowany)
    var left = anchorRect.right - liRect.left + GAP;
    var szerokosc = menu.offsetWidth || 224;

    if (liRect.left + left + szerokosc > window.innerWidth - 8) {
      menu.classList.add('fl-l4--flip');
      menu.style.insetInlineEnd = (liRect.right - anchorRect.left + GAP) + 'px';
    } else {
      menu.style.insetInlineStart = left + 'px';
    }

    // wyrownanie w pionie do wiersza ze strzalka
    menu.style.top = (anchorRect.top - liRect.top - 8) + 'px';
  }

  /* Kolumna mega-nav z otwartym flyoutem idzie nad pozostale kolumny, a przodkowie
     z overflow hidden/auto (animacje motywu) dostaja chwilowo overflow: visible. */
  function raiseColumn(li) {
    document.querySelectorAll('.fl-col-raised').forEach(function (c) {
      c.classList.remove('fl-col-raised');
    });
    document.querySelectorAll('.fl-clip-fix').forEach(function (c) {
      c.classList.remove('fl-clip-fix');
    });
    if (!li || !isDesktop()) return;
    var col = li.closest('.child-nav > li') || li.closest('.main-nav__child > li');
    if (col) col.classList.add('fl-col-raised');
    var el = li.parentElement;
    while (el && !el.classList.contains('main-menu')) {
      var cs = getComputedStyle(el);
      if (cs.overflow !== 'visible' || cs.overflowX !== 'visible' || cs.overflowY !== 'visible') {
        el.classList.add('fl-clip-fix');
      }
      el = el.parentElement;
    }
  }

  /* Watchdog na bug motywu: przy zamykaniu top-level dropdownu (np. wyjscie
     z mega-nav na link bez submenu) transitionend na .main-nav__child czasem
     nie dociera i li zostaje z 'is-open' bez 'is-visible' (panel opacity 0).
     Skutek: ponowny hover nic nie otwiera (openMenuFromMouseEnter wychodzi
     przy is-open), a trigger jest trwale podkreslony. Sprzatamy stan, ktory
     utrzymuje sie ponad 700 ms — okno otwierania (2 x rAF) trwa ~30 ms. */
  var stuckSince = new WeakMap();
  setInterval(function () {
    if (!isDesktop()) return;
    document.querySelectorAll('.main-nav__item--dropdown.is-open:not(.is-visible)').forEach(function (li) {
      var panel = li.querySelector(':scope > .main-nav__child');
      if (!panel || getComputedStyle(panel).opacity !== '0') {
        stuckSince.delete(li);
        return;
      }
      var od = stuckSince.get(li);
      if (!od) {
        stuckSince.set(li, Date.now());
      } else if (Date.now() - od > 700) {
        li.classList.remove('is-open');
        stuckSince.delete(li);
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
      }
    });
  }, 400);

  /* Desktop z myszka: flyout otwiera sie po najechaniu na wiersz 3. poziomu
     (klik w strzalke zostaje jako fallback dla dotyku/klawiatury).
     Zamkniecie z opoznieniem — kursor moze przeciac przerwe do flyoutu. */
  var hoverCloseTimer = null;
  var canHover = window.matchMedia('(hover: hover)');

  function setL4(li, open) {
    li.classList.toggle('fl-l4-open', open);
    var btn = li.querySelector('.fl-l4-toggle');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAllL4() {
    document.querySelectorAll('.fl-l4-open').forEach(function (li) {
      setL4(li, false);
    });
    raiseColumn(null);
  }

  function openL4(li) {
    var panel = li.closest('.main-nav__child') || document;
    panel.querySelectorAll('.fl-l4-open').forEach(function (other) {
      if (other !== li) setL4(other, false);
    });
    if (!li.classList.contains('fl-l4-open')) {
      setL4(li, true);
      positionFlyout(li);
      raiseColumn(li);
    }
  }

  function bindHover(root) {
    (root || document).querySelectorAll('.fl-l4').forEach(function (menu) {
      var li = menu.parentElement;
      if (!li || li.dataset.flHoverBound) return;
      li.dataset.flHoverBound = '1';
      li.addEventListener('mouseenter', function () {
        if (!isDesktop() || !canHover.matches) return;
        clearTimeout(hoverCloseTimer);
        openL4(li);
      });
      li.addEventListener('mouseleave', function () {
        if (!isDesktop() || !canHover.matches) return;
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = setTimeout(closeAllL4, 220);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindHover(); });
  } else {
    bindHover();
  }
  document.addEventListener('shopify:section:load', function (evt) { bindHover(evt.target); });
  window.addEventListener('load', function () { bindHover(); });

  document.addEventListener('click', function (evt) {
    var l4Toggle = evt.target.closest('.fl-l4-toggle');
    if (l4Toggle) {
      evt.preventDefault();
      evt.stopPropagation();
      var li = l4Toggle.closest('li');
      // na desktopie tylko jedno podmenu naraz (flyouty by na siebie nachodzily)
      if (isDesktop()) {
        var panel = li.closest('.main-nav__child') || document;
        panel.querySelectorAll('.fl-l4-open').forEach(function (other) {
          if (other !== li) {
            other.classList.remove('fl-l4-open');
            var btn = other.querySelector('.fl-l4-toggle');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });
      }
      var open = li.classList.toggle('fl-l4-open');
      l4Toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        positionFlyout(li);
        raiseColumn(li);
      } else {
        raiseColumn(null);
      }
      return;
    }

    // klik poza flyoutem zamyka go (desktop)
    if (isDesktop() && !evt.target.closest('.fl-l4')) {
      document.querySelectorAll('.fl-l4-open').forEach(function (li2) {
        li2.classList.remove('fl-l4-open');
        var btn2 = li2.querySelector('.fl-l4-toggle');
        if (btn2) btn2.setAttribute('aria-expanded', 'false');
      });
      raiseColumn(null);
    }

    var crumbBtn = evt.target.closest('.fl-crumb__btn .icon, .fl-crumb__toggle');
    if (crumbBtn) {
      // chevron w okruszku: na urzadzeniach dotykowych klik przelacza dropdown
      var crumb = crumbBtn.closest('.fl-crumb');
      if (crumb && !window.matchMedia('(hover: hover)').matches) {
        evt.preventDefault();
        var wasOpen = crumb.classList.contains('is-open');
        document.querySelectorAll('.fl-crumb.is-open').forEach(function (c) {
          c.classList.remove('is-open');
        });
        if (!wasOpen) crumb.classList.add('is-open');
        return;
      }
    }

    if (!evt.target.closest('.fl-crumb')) {
      document.querySelectorAll('.fl-crumb.is-open').forEach(function (c) {
        c.classList.remove('is-open');
      });
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') {
      document.querySelectorAll('.fl-crumb.is-open, .fl-l4-open').forEach(function (c) {
        c.classList.remove('is-open', 'fl-l4-open');
      });
    }
  });
})();
